module.exports = __webpack_public_path__ + "img/4763d8c007a18cea8d4fb5f563820df6.png";